import { UserPatrimoineSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const UserPatrimoineModel: SelectorModel = {
  name: 'userPatrimoines',
  getSelector: UserPatrimoineSelectors.selectAllUserPatrimoinesDictionary,
  isReady: UserPatrimoineSelectors.selectIsReadyUserPatrimoine
};
